export default __webpack_public_path__ + "static/media/next.8897a781.svg";